var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.24825 2.22222H8.99302C9.61129 2.22222 10.1171 1.72222 10.1171 1.11111C10.1171 0.5 9.61129 0 8.99302 0H2.24825C1.01171 0 0 1 0 2.22222V17.7778C0 19 1.01171 20 2.24825 20H8.99302C9.61129 20 10.1171 19.5 10.1171 18.8889C10.1171 18.2778 9.61129 17.7778 8.99302 17.7778H2.24825V2.22222Z",
    fill: "#434242"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8422 9.61017L16.7059 6.51017C16.3461 6.15461 15.7391 6.39906 15.7391 6.89906V8.88795H7.87022C7.25195 8.88795 6.74609 9.38795 6.74609 9.99906C6.74609 10.6102 7.25195 11.1102 7.87022 11.1102H15.7391V13.0991C15.7391 13.5991 16.3461 13.8435 16.6946 13.4879L19.8309 10.3879C20.0558 10.1768 20.0558 9.82128 19.8422 9.61017Z",
    fill: "#434242"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.7c88fce5ccc7aef89aeb283bb360a5cb.svg";
export { ForwardRef as ReactComponent };